<template>
  <a-form-item
    :label="data.fieldname"
    class="file_item"
  >
    <a-upload
      :multiple="true"
      :headers="{'X-Requested-With': null}"
      :default-file-list="fileList"
      @preview="onPreview"
    />
    <gallery />
  </a-form-item>
</template>

<script>
import Gallery from '@/components/pc/Gallery'

export default {
  components: {
    Gallery
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
    }
  },
  computed: {
    fileList () {
      return this.data.fieldvalue.filter(item => item.file_url !== '').map(item => {
        item.uid = item.id || 'uid' + Math.random()
        item.name = item.file_name || item.name
        item.url = item.file_url
        item.description = item.name
        item.href = item.file_url
        item.title = this.$t('message["1304"]')
        return item
      })
    }
  },
  methods: {
    onPreview (file) {
      if (file.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          onOk: () => {
            // window.open(file.url || file.file_url)
            this.$downloadFile(file.url || file.file_url)
          }
        })
      } else {
        let i = this.fileList.findIndex(item => item.file_url === file.file_url)
        this.$bus.$emit('getFileGallery', this.fileList, i)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.file_item ::v-deep {
  .anticon-close {
    display: none;
  }
  .blueimp-gallery {
    background: rgba(0, 0, 0, 0.6);
    > .slides {
      > .slide {
        height: 60%;
        top: 10%;
      }
    }
  }

  .blueimp-gallery > .description {
    position: absolute;
    top: 75%;
    left: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }
  .blueimp-gallery > .next,
  .blueimp-gallery > .prev,
  .blueimp-gallery > .title {
    top: 90%;
    left: 50%;
    right: 0;
    width: 32px;
    height: 32px;
    margin-top: -16px;
    font-size: 0;
    line-height: 32px;
    background: #fff;
    border-radius: 4px;
    text-shadow: none;
    border: none;
    opacity: 1;
    cursor: pointer;
    .iconfont {
      font-size: 20px;
      color: #333;
    }
  }
  .blueimp-gallery > .prev {
    margin-left: 16px;
  }
  .blueimp-gallery > .next {
    margin-left: 56px;
  }
  .blueimp-gallery > .title {
    width: 82px;
    margin-left: -86px;
    font-size: 14px;
    text-align: center;
    color: #333;
    background-color: #f5f5f5;
  }
  .blueimp-gallery > .close {
    font-size: 32px;
    text-shadow: none;
  }
}
</style>
